import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { UserContext } from "../context/UserContext";
import { ContentContext } from "../context/ContentContext";
import { useParams, useHistory } from "react-router-dom";
import {
  Box,
  Container,
  Heading,
  Stack,
  Input,
  Checkbox,
  Button,
  ButtonGroup,
  FormControl,
  FormLabel,
  FormHelperText,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  useToast,
} from "@chakra-ui/react";

const GameForm = () => {
  const { user } = useContext(UserContext);
  const { games, setGames, fetch, setFetch } = useContext(ContentContext);
  const [input, setInput] = useState({});
  const { id } = useParams();
  const history = useHistory();
  const toast = useToast();

  useEffect(() => {
    axios
      .get(`https://backendexample.sanbersy.com/api/data-game/${id}`)
      .then((res) => {
        setInput({
          id: res.data.id,
          name: res.data.name,
          genre: res.data.genre,
          release: res.data.release,
          platform: res.data.platform,
          singlePlayer: res.data.singlePlayer,
          multiPlayer: res.data.multiPlayer,
          image: res.data.image_url,
        });
      });
  }, []);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setInput({ ...input, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let singlePlayer = event.target[4].checked;
    let multiPlayer = event.target[5].checked;
    if (id) {
      axios
        .put(`https://backendexample.sanbersy.com/api/data-game/${id}`, {
          name: input.name,
          genre: input.genre,
          release: input.release,
          platform: input.platform,
          singlePlayer: singlePlayer,
          multiplayer: multiPlayer,
          image_url: input.image,
          token: user.token,
        })
        .then(() => {
          let game = games.find((element) => element.id === parseInt(id));
          game.name = input.name;
          game.genre = input.genre;
          game.release = input.release;
          game.platform = input.platform;
          game.singlePlayer = singlePlayer;
          game.multiPlayer = multiPlayer;
          game.image = input.image;
          history.push("/game/list");
          setFetch(!fetch);
          toast({
            title: "Edit game success",
            position: "top",
            status: "success",
            duration: 1500,
          });
        });
    } else {
      axios
        .post(`https://backendexample.sanbersy.com/api/data-game`, {
          name: input.name,
          genre: input.genre,
          release: input.release,
          platform: input.platform,
          singlePlayer: singlePlayer,
          multiplayer: multiPlayer,
          image_url: input.image,
          token: user.token,
        })
        .then((res) => {
          let data = res.data;

          setGames([
            ...games,
            {
              id: data.id,
              name: data.name,
              genre: data.genre,
              release: data.release,
              platform: data.platform,
              singlePlayer: singlePlayer,
              multiPlayer: multiPlayer,
              image: data.image_url,
            },
          ]);
          history.push("/game/list");
          setFetch(!fetch);
          toast({
            title: "Add game success",
            position: "top",
            status: "success",
            duration: 1500,
          });
        });
    }
  };

  return (
    <Box p={4}>
      <Container maxW="container.lg" p={4}>
        <Heading>{id ? "Edit Game" : "Add Game"}</Heading>
        <form onSubmit={handleSubmit}>
          <Stack spacing="1rem" py={4}>
            <FormControl>
              <FormLabel id="name" isRequired>
                Game Name
              </FormLabel>
              <Input name="name" value={input.name} onChange={handleChange} />
              <FormHelperText>Provide a game name</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="platform" isRequired>
                Platform
              </FormLabel>
              <Input
                name="platform"
                value={input.platform}
                onChange={handleChange}
              />
              <FormHelperText>Provide a platform</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="release" isRequired>
                Game Release Year
              </FormLabel>
              <NumberInput value={input.release}>
                <NumberInputField
                  name="release"
                  min="2000"
                  max="2021"
                  value={input.release}
                  onChange={handleChange}
                />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
              <FormHelperText>Provide game release year</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="genre" isRequired>
                Game Genre
              </FormLabel>
              <Input name="genre" value={input.genre} onChange={handleChange} />
              <FormHelperText>Provide a genre for this game</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="game-type" isRequired>
                Game Type
              </FormLabel>
              <Stack spacing={10} direction="row">
                <Checkbox
                  name="singlePlayer"
                  aria-label="checkbox for game type"
                  checked={games.singlePlayer}
                  onChange={handleChange}
                >
                  Single Player
                </Checkbox>
                <Checkbox
                  name="multiplayer"
                  aria-label="checkbox for game type"
                  checked={games.multiplayer}
                  onChange={handleChange}
                >
                  Multi Player
                </Checkbox>
              </Stack>
              <FormHelperText>
                Provide game type (single player or multi player)
              </FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="image-url" isRequired>
                Game Poster
              </FormLabel>
              <Input name="image" value={input.image} onChange={handleChange} />
              <FormHelperText>Provide a game poster</FormHelperText>
            </FormControl>
            <ButtonGroup spacing="4">
              <Button
                type="submit"
                colorScheme="red"
                variant="outline"
                onClick={() => history.push("/movie/list")}
              >
                Cancel
              </Button>
              <Button type="submit" colorScheme="teal" variant="solid">
                Save
              </Button>
            </ButtonGroup>
          </Stack>
        </form>
      </Container>
    </Box>
  );
};

export default GameForm;
